import type { IMediaLibUploadingFile } from "@editor/modules/media-lib";
import { MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS } from "@editor/modules/media-lib/constants";
import { useEffect, useRef } from "react";

interface IProps {
  uploadingFile: IMediaLibUploadingFile;
}

const TOTAL_DUR = 10 * 1000; // 10 seconds

export const MediaLibFileUploading = ({ uploadingFile }: IProps) => {
  "use no memo";
  const progressRef = useRef(0);
  const loaderRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const PARTS = Math.floor(Math.random() * 6) + 4;

    let interval: NodeJS.Timeout | null = setInterval(() => {
      const loader = loaderRef.current;
      if (!loader) return;

      progressRef.current = Math.min(90, progressRef.current + 100 / PARTS);
      loader.style.width = `${progressRef.current}%`;

      if (progressRef.current >= 90) {
        clearInterval(interval!);
        interval = null;
      }
    }, TOTAL_DUR / PARTS);

    return () => {
      if (interval != null) {
        clearInterval(interval);
      }
    };
  }, []);

  return (
    <div
      className="tw-grid tw-place-items-center tw-rounded tw-bg-blue-100 tw-outline tw-outline-1 tw-outline-offset-1 tw-outline-primary"
      style={{ height: MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS[0][0] }}
      key={uploadingFile.id}
    >
      <div className="tw-h-1.5 tw-w-4/5 tw-overflow-hidden tw-rounded-full tw-bg-blue-300">
        <div
          className="tw-h-full tw-rounded-full tw-bg-primary tw-transition-all tw-duration-200 tw-ease-linear"
          style={{ width: `${progressRef.current}%` }}
          ref={loaderRef}
        />
      </div>
    </div>
  );
};
